import { useGetWallets } from "../../store/actions/wallet";

export const useGetWalletOptions = () =>
  useGetWallets((data) =>
    data.wallets.map<SelectOptionType>((wallet) => ({
      value: wallet._id,
      label: wallet.customName || wallet.dataSource.name,
      icon: wallet.dataSource.image,
      description: "",
    }))
  );
